@if (ordered.length > 0) {
  <section class="mt-4">
    <h4 class="font-weight-bold w-100 mb-2 d-flex align-items-center section-title-purple">
      <mat-icon class="section-icon mr-2">folder_open</mat-icon>
      {{ 'components.statement-documents.title' | translate }}
      <span class="text-muted font-weight-normal ml-2">{{ ordered.length }}</span>
    </h4>

    <div class="border-top">
      @for (attachment of visible; track trackBy($index, attachment)) {
        <div class="d-flex align-items-center py-2 border-bottom">
          <button type="button" class="border-0 bg-transparent p-0 mr-3 flex-shrink-0" style="cursor: zoom-in" (click)="open(attachment)"
            [attr.aria-label]="('components.statement-documents.open' | translate) + ' ' + attachment.title">
            <app-attachment-thumbnail [attachment]="attachment" [surveyId]="surveyId" [questionId]="questionId" [width]="32" [height]="40"></app-attachment-thumbnail>
          </button>

          <div class="flex-grow-1 overflow-hidden">
            <div class="d-flex align-items-center text-dark">
              <span class="text-truncate" [matTooltip]="attachment.title">{{ attachment.title }}</span>
              @if (attachment.is_primary) {
                <mat-icon class="text-warning ml-1 flex-shrink-0" inline [matTooltip]="'components.statement-documents.primary' | translate">star</mat-icon>
              }
              @if (attachment.is_read_only) {
                <mat-icon class="text-muted ml-1 flex-shrink-0" inline [matTooltip]="'components.statement-documents.read-only' | translate">lock</mat-icon>
              }
            </div>
            <div class="small text-muted text-truncate" [matTooltip]="attachment.reference || ''">
              <span class="text-uppercase">{{ attachment.type === 'FILE' ? (attachment.ext || 'file') : attachment.type }}</span>
              @if (attachment.reference) {
                · {{ attachment.reference }}
              }
            </div>
          </div>

          <button mat-button color="primary" type="button" class="ml-2 flex-shrink-0 text-nowrap" (click)="open(attachment)"
            [attr.aria-label]="('components.statement-documents.open' | translate) + ' ' + attachment.title">
            {{ 'components.statement-documents.open' | translate }}
            @if (attachment.type === 'FILE' && preview.kind(attachment) === 'pdf' && preview.pageOf(attachment) > 1) {
              <span class="d-none d-md-inline">· {{ 'components.statement-documents.page-short' | translate: { page: preview.pageOf(attachment) } }}</span>
            }
            @if (attachment.type !== 'FILE') {
              <mat-icon iconPositionEnd>open_in_new</mat-icon>
            }
          </button>
        </div>
      }
    </div>

    @if (hiddenCount > 0) {
      <button mat-button color="primary" type="button" class="mt-1 px-0" (click)="expanded = !expanded">
        @if (expanded) {
          {{ 'components.statement-documents.show-less' | translate }}
        } @else {
          {{ 'components.statement-documents.show-all' | translate: { count: ordered.length } }}
        }
        <mat-icon iconPositionEnd>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    }
  </section>
}
